import {
  createReducer,
  updateObject,
  updateItemInArray,
} from 'helpers/ReducerUtil'
import {
  UPDATE_LINK_TYPE_VALUE,
  UPDATE_CONNECTOR_LOCATION_VALUE,
  UPDATE_CONNECTOR_FEATURE_VALUE,
  UPDATE_CONNECTOR_SOURCE_VALUE,
  UPDATE_CONNECTOR_TYPE_VALUE,
  ADD_DISPLAY_CONNECTOR,
  REMOVE_DISPLAY_CONNECTOR,
} from './constants'

const updateLinkTypeValue = (values, action) => {
  const { index, linkType } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { linkType })
  ))
}

const updateConnectorLocationValue = (values, action) => {
  const { index, connectorLocation } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { connectorLocation })
  ))
}

const updateConnectorSourceValue = (values, action) => {
  const { index, connectorSource } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { connectorSource })
  ))
}

const updateConnectorFeatureValue = (values, action) => {
  const { index, connectorFeature } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { connectorFeature })
  ))
}

const updateConnectorTypeValue = (values, action) => {
  const { index, connectorType } = action
  return updateItemInArray(values, index, value => (
    updateObject(value, { connectorType })
  ))
}

const addDisplayConnector = (values, action) => [
  ...values, {
    connectorFeature: '',
    connectorType: '',
    connectorSource: '',
    linkType: '',
    connectorLocation: ''
  }
]
const removeDisplayConnector = (values, action) => values.filter((val, index) => index !== action.index)

const displayConnectorReducer = createReducer([], {
  [UPDATE_LINK_TYPE_VALUE]: updateLinkTypeValue,
  [UPDATE_CONNECTOR_LOCATION_VALUE]: updateConnectorLocationValue,
  [UPDATE_CONNECTOR_FEATURE_VALUE]: updateConnectorFeatureValue,
  [UPDATE_CONNECTOR_SOURCE_VALUE]: updateConnectorSourceValue,
  [UPDATE_CONNECTOR_TYPE_VALUE]: updateConnectorTypeValue,
  [ADD_DISPLAY_CONNECTOR]: addDisplayConnector,
  [REMOVE_DISPLAY_CONNECTOR]: removeDisplayConnector,
})

export default displayConnectorReducer
